import { createSlice } from "@reduxjs/toolkit"

const initialStateFiltrosObservaciones = {
  intIdObservacion: -1,
  fechaAltaInicio: "",
  fechaAltaFin: "",
  idJuicio: -1,
  nroExpediente: "",
  caratula: "",
  observacion: "",
  nroSiniestro: "",
  idDelegacion: -1,
  idProfesional: -1,
  idEstadoObservacion: -1,
  idTipoMotivoRechazo: -2,
  cuitLetrado: "",
  cargados: false,
  filtroRapido: ""
};

export const filtroObservacionSlice = createSlice({
  name: "filtroObservacion",
  initialState: initialStateFiltrosObservaciones,
  reducers: {
    addFiltrosObservacion: (state, action) => {
      const { intIdObservacion, fechaAltaInicio, fechaAltaFin, idJuicio, nroExpediente, caratula, observacion, nroSiniestro, idDelegacion, idProfesional, idEstadoObservacion, idTipoMotivoRechazo, cuitLetrado } = action.payload
      state.intIdObservacion = intIdObservacion
      state.fechaAltaInicio = fechaAltaInicio
      state.fechaAltaFin = fechaAltaFin
      state.idJuicio = idJuicio
      state.nroExpediente = nroExpediente
      state.caratula = caratula
      state.observacion = observacion
      state.nroSiniestro = nroSiniestro
      state.idDelegacion = idDelegacion
      state.idProfesional = idProfesional
      state.idEstadoObservacion = idEstadoObservacion
      state.idTipoMotivoRechazo = idTipoMotivoRechazo
      state.cuitLetrado = cuitLetrado-1
    },
    resetFiltrosObservacion: (state) => {
      state.intIdObservacion = initialStateFiltrosObservaciones.intIdObservacion
      state.fechaAltaInicio = initialStateFiltrosObservaciones.fechaAltaInicio
      state.fechaAltaFin = initialStateFiltrosObservaciones.fechaAltaFin
      state.idJuicio = initialStateFiltrosObservaciones.idJuicio
      state.nroExpediente = initialStateFiltrosObservaciones.nroExpediente
      state.caratula = initialStateFiltrosObservaciones.caratula
      state.observacion = initialStateFiltrosObservaciones.observacion
      state.nroSiniestro = initialStateFiltrosObservaciones.nroSiniestro
      state.idDelegacion = initialStateFiltrosObservaciones.idDelegacion
      state.idProfesional = initialStateFiltrosObservaciones.idProfesional
      state.idEstadoObservacion = initialStateFiltrosObservaciones.idEstadoObservacion
      state.idTipoMotivoRechazo = initialStateFiltrosObservaciones.idTipoMotivoRechazo
      state.cuitLetrado = initialStateFiltrosObservaciones.cuitLetrado
      state.cargados = initialStateFiltrosObservaciones.cargados
      state.filtroRapido = initialStateFiltrosObservaciones.filtroRapido
    },
    setFiltrosCargados: (state, action) => {
      state.cargados = action.payload
    },
    addFiltroRapidoObservacion: (state, action) => {
      state.filtroRapido = action.payload
    },
  }
});

export const { addFiltroRapidoObservacion, resetFiltrosObservacion, setFiltrosCargados, addFiltrosObservacion } = filtroObservacionSlice.actions
export default filtroObservacionSlice.reducer
